export default {
  init() {
    // JavaScript to be fired on the home page
    setTimeout( function() {
      aktionFadeIn();
    }, 5000 );

    /* setTimeout( function() {
      //aktionFadeOut();
    }, 10000 ); 

    var scrolling = false;

    $( window ).scroll( function() {
      scrolling = true;
    }); 

    setInterval( function() {
      if ( scrolling ) {
        scrolling = false;    
        if ($(document).scrollTop() > 600) {
          aktionFadeOut();
        }
      }
    }, 250 ); */

    $('.aktion-startseite-wrapper .close, .wrap.container-fluid, footer.content-info, .jumbotron').on('click', function(){
      aktionFadeOut();
    });

    function aktionFadeIn() {
      $('.aktion-startseite-wrapper').css({opacity: 0, display: 'flex'}).animate({
        opacity: 1,
      } , 500, function() {
          // Animation complete.
        }
      );
    }

    function aktionFadeOut() { // eslint-disable-line no-unused-vars
      $('.aktion-startseite-wrapper').animate({
        opacity: 0,
      } , 500, function() {
          // Animation complete.
          $(this).css({display: 'none'})
        }
      );
    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js